module.exports = __webpack_public_path__ + "img/part11.23005992.jpg";